import { FugitiveCategory, FugitiveType, TreatmentMethod } from '@/app/org-cfv/src/enums/FugitiveEmissionEnum';
export enum FugitiveCategoryType {
  AEROSOL_SPRAY = 'AEROSOL_SPRAY', // 噴霧劑
  REFRIGERANT = 'REFRIGERANT', // 冷媒
  SEPTIC_TANK = 'SEPTIC_TANK', // 化糞池
  WASTEWATER = 'WASTEWATER', // 廢水處理
  OTHER = 'OTHER',
}

export enum TreatmentMethodType {
  COLLECTED = 'COLLECTED', // 納管
  UNCOLLECTED = 'UNCOLLECTED', // 未納管
}

export enum WastewaterType {
  COMMERCIAL = 'COMMERCIAL', // 商業用水
  INDUSTRIAL = 'INDUSTRIAL', // 工業用水
  OTHER = 'OTHER',
}

export const getFugitiveCategoryType = (
  fugitiveCategory?: FugitiveCategory | string | null,
): FugitiveCategoryType | undefined => {
  switch (fugitiveCategory) {
    case FugitiveCategory.FC_3:
    case FugitiveCategory.JP_FC_5:
      return FugitiveCategoryType.AEROSOL_SPRAY;
    case FugitiveCategory.FC_4:
    case FugitiveCategory.JP_FC_10:
    case FugitiveCategory.MX_FC_2:
    case FugitiveCategory.IN_FC_1:
    case FugitiveCategory.CA_FC_1:
    case FugitiveCategory.SG_FC_1:
      return FugitiveCategoryType.REFRIGERANT;
    case FugitiveCategory.FC_7:
    case FugitiveCategory.JP_FC_7:
      return FugitiveCategoryType.SEPTIC_TANK;
    case FugitiveCategory.FC_14:
    case FugitiveCategory.JP_FC_9:
    case FugitiveCategory.ADEME_FC_4:
      return FugitiveCategoryType.WASTEWATER;
    case FugitiveCategory.FC_OT:
    default:
      return FugitiveCategoryType.OTHER;
  }
};

export const getWastewaterType = (fugitiveType?: FugitiveType | string | null): WastewaterType | undefined => {
  switch (fugitiveType) {
    case FugitiveType.FT_14_1:
    case FugitiveType.ADEME_FT_4_1:
      return WastewaterType.COMMERCIAL;
    case FugitiveType.FT_14_2:
      return WastewaterType.INDUSTRIAL;
    case FugitiveType.FT_OTHER:
      return WastewaterType.OTHER;
  }
};

export const getTreatmentMethodType = (
  treatmentMethod?: TreatmentMethod | string | null,
): TreatmentMethodType | undefined => {
  switch (treatmentMethod) {
    case TreatmentMethod.TM_1_R:
    case TreatmentMethod.TM_2_R:
      return TreatmentMethodType.COLLECTED;
    case TreatmentMethod.TM_3:
      return TreatmentMethodType.UNCOLLECTED;
  }
};

export const WASTE_WATER_TYPES = [WastewaterType.COMMERCIAL, WastewaterType.INDUSTRIAL];
